/**
 * Enumeraciones globales del sistema
 */

export enum UserRole {
  PLATFORM_ADMIN = 'PLATFORM_ADMIN',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  SALESPERSON = 'SALESPERSON',
  APPROVER = 'APPROVER',
}

export enum QuoteStatus {
  DRAFT = 'DRAFT',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  FROZEN = 'FROZEN',
  EXPIRED = 'EXPIRED',
  ADJUSTMENT_REQUESTED = 'ADJUSTMENT_REQUESTED',
  CANCELLED = 'CANCELLED',
}

export enum ApprovalStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ADJUSTMENT_REQUESTED = 'ADJUSTMENT_REQUESTED',
  CANCELLED = 'CANCELLED',
}

export enum VariableType {
  NUMBER = 'NUMBER',
  PERCENTAGE = 'PERCENTAGE',
  CURRENCY = 'CURRENCY',
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
  CALCULATED = 'CALCULATED',
  ENUM = 'ENUM',
  TIERED = 'TIERED',
  LOOKUP = 'LOOKUP',
}

export enum PaymentType {
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  INSTALLMENTS = 'INSTALLMENTS',
}

export enum TaxType {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED',
}

export enum LOBLevel {
  SECTOR = 'SECTOR',
  VERTICAL = 'VERTICAL',
  PRODUCT = 'PRODUCT',
}

export enum DocumentStatus {
  DRAFT = 'DRAFT',
  GENERATED = 'GENERATED',
  FROZEN = 'FROZEN',
}

export enum PlanTier {
  DEMO = 'DEMO',
  TRIAL = 'TRIAL',
  BASIC = 'BASIC',
  PROFESSIONAL = 'PROFESSIONAL',
  ENTERPRISE = 'ENTERPRISE',
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  SUSPENDED = 'SUSPENDED',
  CANCELLED = 'CANCELLED',
}

export enum PricingModelType {
  STANDARD = 'STANDARD',
  SUBSCRIPTION = 'SUBSCRIPTION',
  BUNDLE = 'BUNDLE',
  GOOD_BETTER_BEST = 'GOOD_BETTER_BEST',
  CUSTOMER_SPECIFIC = 'CUSTOMER_SPECIFIC',
  TCO_ROI = 'TCO_ROI',
  PROMOTIONAL = 'PROMOTIONAL',
  USAGE_BASED = 'USAGE_BASED',
  COST_PLUS = 'COST_PLUS',
  DYNAMIC = 'DYNAMIC',
  LEASING = 'LEASING',
  MANAGED_SERVICE = 'MANAGED_SERVICE',
  TIERED_VOLUME = 'TIERED_VOLUME',
  FREEMIUM = 'FREEMIUM',
  PROJECT_BASED = 'PROJECT_BASED',
  HYBRID = 'HYBRID',
  AUCTION = 'AUCTION',
}
